import { FC } from "react";
import CellBox from "../../../components/common/table/CellBox";
import BorderRow from "../../../components/common/table/BorderRow";
import { BasicTableRowStyles } from "../../../components/common/Common.styles";
import TooltipTypography from "../../../components/common/TooltipTypography";
import { LeaderboardEntry } from "../../../types/serviceModuleTypes";

interface LeaderboardTableRowProps {
  item: LeaderboardEntry;
}

const LeaderboardTableRow: FC<LeaderboardTableRowProps> = ({ item }) => {
  return (
    <BasicTableRowStyles>
      <CellBox firstCol>
        <TooltipTypography value={item.rank} />
      </CellBox>
      <CellBox>
        <TooltipTypography value={item.firstName} />
      </CellBox>
      <CellBox>
        <TooltipTypography value={item.lastName} />
      </CellBox>
      <CellBox>
        <TooltipTypography value={item.position} />
      </CellBox>
      <CellBox contentPosition="center">
        <TooltipTypography value={item.employeeNumber} />
      </CellBox>
      <CellBox>
        <TooltipTypography value={item.score} />
      </CellBox>
      <BorderRow />
    </BasicTableRowStyles>
  );
};

export default LeaderboardTableRow;
